import { Button } from "@sellar-io/components";
import dayjs from "dayjs";
import { ReactElement } from "react";
import { SpinnerLegacy } from "../../components";
import { Alert } from "../../components/alert/Alert";
import {
  Dialog,
  DialogNavigation,
  DialogContent,
  DialogCTA,
} from "../../components/modal/Dialog";
import { apiV2AssertError } from "../../hooks/api/v2/apiV2Request";
import { useCollectionFinalise } from "../../hooks/api/v2/collections/useCollectionFinalise";

export function FinaliseCollectionDialog({
  active,
  collectionId,
  onDismiss,
  collectionDate,
}: {
  active: boolean;
  collectionId: number;
  collectionDate: Date;
  onDismiss: () => void;
}): ReactElement {
  const finaliseCollectionMutation = useCollectionFinalise(collectionId);
  const finalise = () => {
    finaliseCollectionMutation.mutate(undefined, {
      onSuccess: () => onDismiss(),
    });
  };
  return (
    <Dialog active={active} onDismiss={onDismiss}>
      <DialogNavigation
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={onDismiss}
        title={`Finalise collection for ${dayjs(collectionDate).format(
          "dddd DD MMMM",
        )}?`}
        description={"Are you sure you want to finalise this collection?"}
      />
      <DialogContent>
        {finaliseCollectionMutation.isError ? (
          <Alert
            type={"error"}
            message={
              apiV2AssertError(finaliseCollectionMutation.error)?.response?.data
                .message ?? "An unknown error occurred"
            }
          />
        ) : (
          <>{finaliseCollectionMutation.isPending && <SpinnerLegacy />}</>
        )}
      </DialogContent>
      <DialogCTA>
        <Button onClick={finalise}>Finalise collection</Button>
      </DialogCTA>
    </Dialog>
  );
}
